<template>
    <a-select
        :placeholder="$t('chatbotv2.chooseASegment')"
        class="w-100 segment-picker"
        :notFoundContent="$t('chatbotv2.noSegmentFound')"
        size="large"
        v-model="selectedSegmentId"
        @change="handleChange"
        @search="handleSearch"
        @select="handleSelect"
        show-search
        :filter-option="false"
    >
        <a-select-option v-if="loading" :key="'loading'"> {{ $t("chatbotv2.loading") }} ....</a-select-option>
        <a-select-option v-for="(segment, index) of getFilteredResult()" :value="segment._id" :key="index">
            <div class="item-container">
                <div class="title">
                    <div class="logo-container">
                        <a-avatar class="avatar" :style="`background-color:${index % 2 === 0 ? '#c980a3' : '#6899c1'}`">
                            {{ segment.name.slice(0, 2).toUpperCase() }}
                        </a-avatar>
                    </div>
                    <div class="content">{{ segment.name }}</div>
                </div>
                <div class="users">{{ segment.users.length }} {{ $t("chatbotv2.users") }}</div>
            </div>
        </a-select-option>
    </a-select>
</template>

<script>
import { mapActions } from "vuex";
import log2 from "../../../../../../utils/log2";
import _ from "lodash";

const log = log2("SegmentPicker");
export default {
    name: "SegmentPicker",
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            segments: [],
            loading: true,
            selectedSegmentId: this.value,
            query: null,
        };
    },
    methods: {
        ...mapActions({
            listSegments: "CB/listSegments",
        }),
        handleChange(segmentId) {
            log(`selected ${segmentId}`);
            this.selectedSegmentId = segmentId;
            this.query = "";
        },
        handleSelect(segmentId) {
            log(`handleSelect ${segmentId}`);
            this.selectedSegmentId = segmentId;
        },
        handleSearch(search) {
            log(`handleSearch ${search}`);
            this.query = search;
        },
        getFilteredResult() {
            const q = (this.query || "").trim().toLowerCase();
            const result = this.segments.filter((segment) => {
                return _.isEmpty(q) || (segment.name || "").toLowerCase().includes(q);
            });
            log("getFilteredResult", result);
            return result;
        },
    },
    mounted() {
        this.loading = true;
        this.listSegments()
            .then((res) => {
                this.segments = res;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    watch: {
        selectedSegmentId(newValue) {
            this.$emit("input", newValue);
        },
        value(newValue) {
            if (this.selectedSegmentId !== newValue) {
                this.selectedSegmentId = newValue;
            }
        },
    },
};
</script>

<style lang="scss">
.segment-picker {
    .ant-select-selection-selected-value {
        width: 100%;
    }
}

.item-container {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    align-items: center;
    width: 100%;

    .title {
        display: flex;

        .logo-container {
            .avatar {
            }
        }

        .content {
            margin-left: 10px;
            font-size: 18px;
            font-weight: 500;
        }
    }

    .content {
    }
}
</style>
